import React, { useEffect } from "react";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface AlertDialogProps {
    open: boolean,
    onClose: () => void,
    message: string,
}

export default function AlertDialog(props: AlertDialogProps) {
  const {t} = useTranslation()

  useEffect(() => {
      setOpen(props.open);
  }, [props.open])

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
      setOpen(false);
      props.onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">{props.message}</DialogTitle>
        <DialogActions>
            <Button onClick={handleClose} color="primary" autoFocus>
              {t("alertDialog.ok")}
            </Button>
        </DialogActions>
    </Dialog>
  )
}